import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListComponent } from './list/list.component';
import { FormComponent } from './form/form.component';
import { DetailsComponent } from './details/details.component';
import {AuthGuard} from '../services/auth.guard';

const routes: Routes = [
  { path: 'services', component: ListComponent, canActivate: [AuthGuard] },
  { path: 'service/add', component: FormComponent, canActivate: [AuthGuard] },
  { path: 'service/:id', component: DetailsComponent, canActivate: [AuthGuard] },
  { path: 'service/:id/edit', component: FormComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageServicesRoutingModule {
}
